import React from 'react';
import {
  Panel,
  RefinementList,
} from 'react-instantsearch-dom';

function PrAgencyFilterPanel() {
  return (
    <div className="card mb-3">
      <div className="card-body">
        <Panel header="Filter by PR agency">
          <RefinementList
            attribute="current_pr_agencies.name"
            limit={6}
            showMore={true}
            showMoreLimit={15}
            searchable={true}
          />
        </Panel>
      </div>
    </div>
  );
}

export default PrAgencyFilterPanel;
